import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Link from 'components/Link';
import buildAffiliateLink from 'lib/buildAffiliateLink';

import {
  image as imagePropType,
  offer as offerPropType,
} from 'lib/CustomPropTypes';

import styles from './productSlide.module.scss';

const linkClickHandler = (e) => {
  e.preventDefault();
};

function ProductSlide(props) {
  const {
    slide: {
      offers,
      teaseImage,
    },
    index,
    slideWidth,
    slideHeight,
    imageHeight,
    activeSlideIndex,
    onSlideMouseDown,
  } = props;

  const maxImageDimension = ((teaseImage.width / slideWidth) > (teaseImage.height / imageHeight))
    ? 'width'
    : 'height';
  const imageHeightString = `${imageHeight}px`;
  const imageWidthString = `${slideWidth}px`;
  const affiliateLink = buildAffiliateLink(offers[0].externalUrl);

  /* eslint-disable jsx-a11y/no-static-element-interactions */
  return (
    <div
      className={classnames(
        styles.slide,
        { [styles.active]: activeSlideIndex === index },
      )}
      style={{
        width: '100%',
        height: `${slideHeight}px`,
      }}
      key={index}
      onMouseDown={onSlideMouseDown}
      data-index={index}
      data-affiliate-link={affiliateLink}
    >
      <div
        className={classnames(
          styles.imageArea,
          { [styles.widthPriorityImage]: maxImageDimension === 'width' },
        )}
        style={{
          height: imageHeightString,
        }}
      >
        <Link
          href={affiliateLink}
          onClick={linkClickHandler}
        >
          <img
            src={teaseImage.url.primary}
            style={{
              [maxImageDimension]: '100%', // stylelint-disable-line property-no-unknown
              maxWidth: imageWidthString,
              maxHeight: imageHeightString,
            }}
            alt={teaseImage.headline.primary}
          />
        </Link>
      </div>
    </div>
  );
  /* eslint-enable jsx-a11y/no-static-element-interactions */
}

ProductSlide.propTypes = {
  slide: PropTypes.shape({
    teaseImage: imagePropType,
    offers: offerPropType,
  }).isRequired,
  index: PropTypes.number.isRequired,
  slideWidth: PropTypes.number.isRequired,
  slideHeight: PropTypes.number.isRequired,
  imageHeight: PropTypes.number.isRequired,
  activeSlideIndex: PropTypes.number.isRequired,
  onSlideMouseDown: PropTypes.func.isRequired,
};

export default ProductSlide;
